export const API = {
  allDeliveryNotes: {
    path: '/delivery-notes?populate=%2A&filters[id_operation_list]={{id}}',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  deliveryNotes: {
    path: '/delivery-notes/{{id}}?populate[id_logbook][populate][id_list_items][populate][id_item]=%2A&populate[id_logbook][populate][id_supplier]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  create: {
    path: '/delivery-notes',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
  },
  downloadPDF: {
    path: '/deliveryNotePDF/{{id}}',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
    responseType: 'blob',
  },
  selectLogbook: {
    path: '/operation-lists/{{id}}?populate[id_list]=%2A&populate[id_yacht][populate][id_attendance][populate][id_agent_NA][populate][id_users_permissions_user][fields][0][1]=name, surname&populate[id_technical_work][populate][id_user_technicians][populate][id_users_permissions_user][fields]=name,surname&populate[id_mexal_person_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_department]=%2A&populate[id_marina]=%2A&populate[id_yacht]=%2A&populate[id_reservation][populate][id_arrival_departure_formality]=%2A&populate[id_user_in_charge][populate][id_users_permissions_user][fields]=name,surname&populate[id_service]=%2A&populate[id_supplier]=%2A&populate[id_reservation_piloti_in][populate][id_yacht]=%2A&populate[id_yacht][populate][id_flag]=%2A&populate[id_technical_works]=%2A&populate[id_user_last_updated][populate][id_users_permissions_user]=%2A&populate[id_delivery_notes]=%2A',
    method: 'GET',
    get: null,
    auth: true,
    fallback: null,
  },
  update: {
    path: '/delivery-notes/{{id}}',
    method: 'PUT',
    get: null,
    auth: true,
    fallback: null,
  },
  supplierOrder: {
    path: '/supplierOrderPDF',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
    responseType: 'blob',
  },
};
